import ResetPassword from '../ResetPassword';

/**
 * Fluxo público de recuperação de senha (visitante).
 * Reusa o mesmo stepper do fluxo logado. A diferença (e-mail pré-preenchido)
 * é resolvida dentro de <ResetPassword /> via useAuth: sem usuário, o passo 1
 * pede o e-mail.
 */
export default function ResetPasswordPublic() {
    return <ResetPassword />;
}
